import React, { createContext, useContext, useEffect, useRef, useMemo, useState } from "react";
import * as Ably from "ably";
import { useSelector } from "react-redux";

const AblyContext = createContext(null);

export const useAbly = () => {
  const context = useContext(AblyContext);
  if (!context) throw new Error("useAbly must be used within AblyWrapper");
  return context;
};

export const AblyWrapper = ({ children }) => {
  const { user } = useSelector(
      (state) => state.auth
    );
  const ablyInstanceRef = useRef(null);
  const channelRef = useRef(null);
  const isInitializedRef = useRef(false);
  const [event, setEvent] = useState(null);

  const ablyChannelName = useMemo(() => `private-user-${user?.user_id}`, [user?.user_id]);

  useEffect(() => {
    if (user?.user_id && user?.user_id != undefined && !isInitializedRef.current) {
      isInitializedRef.current = true;
      const setup = async () => {
        try {
          ablyInstanceRef.current = new Ably.Realtime({ key: 'OavTsQ.3YtA8g:CVamytHGOuH_INS-yNszzA8aGhkW1hdHg9R7oB_utiE' });
          channelRef.current = ablyInstanceRef.current.channels.get(ablyChannelName);

          const channel = channelRef.current;
          await channel.attach();
          console.log("Attached to Ably channel");

          channel.unsubscribe(); // prevent duplicates
          channel.subscribe((message) =>{
            setEvent(message);
          });
        } catch (error) {
          console.error("Ably setup error:", error);
        }
      };
      setup();
    }

    return () => {
      if (channelRef.current) {
        channelRef.current.unsubscribe();
        console.log("Unsubscribed from Ably channel");
      }

      if (ablyInstanceRef.current) {
        ablyInstanceRef.current.close();
        ablyInstanceRef.current = null;
        console.log("Closed Ably instance");
      }

      isInitializedRef.current = false;
    };
  }, [user?.id, ablyChannelName]);

  const publish = async (event, data) => {
    if (!channelRef.current) return;
    await channelRef.current.attach();
    await channelRef.current.publish(event, data);
    console.log("[Ably] Published:", event, data);
  };

  const subscribe = async (event, callback) => {
    if (!channelRef.current) return;
    await channelRef.current.attach();
    channelRef.current.subscribe(event, callback);
  };

  const unsubscribe = (event) => {
    if (!channelRef.current) return;
    channelRef.current.unsubscribe(event);
  };

  const clearEvent = () => setEvent(null);

  return (
    <AblyContext.Provider value={{ publish, subscribe, unsubscribe, clearEvent, event }}>
      {children}
    </AblyContext.Provider>
  );
};